/* eslint-disable global-require */
const axios = require('axios')

// Cria a instância do axios com a URL base
const api = axios.create({
  baseURL: 'https://chat-api.manyconvert.com',
})

const apiAnalytics = axios.create({
  baseURL: 'https://mc-analytics.manyconvert.com',
})

async function getChatOfContact(ticketID, { limit = 100, before, signal } = {}) {
  const params = new URLSearchParams()
  params.append('limit', limit)
  if (before) params.append('before', before)
  const res = await api.get(`/api/messages/history/${ticketID}?${params.toString()}`, { signal })
  return res.data
}

async function getAttendings(accountId, data) {
  console.log(`/api/messages/atendimentos/${accountId}?pagina=${data.pagina}&limit=${data.limite}&corteAntesDe=${data.corteAntesDe}`)
  const res = await api.get(`/api/messages/atendimentos/${accountId}?pagina=${data.pagina}&limit=${data.limite}&corteAntesDe=${data.corteAntesDe}`)
  return res.data
}

async function sendMessage(data) {
  const body = { ...data }
  if (body.type === 'text') {
    const msg = body.message
    if ((body.text == null || body.text === '') && msg != null && msg !== '') {
      body.text = msg
    }
  }
  const res = await api.post('/api/messages/send', body)
  return res.data
}

async function enviarAnexo(arquivo, onProgress = () => {}) {
  const formData = new FormData()
  formData.append('file', arquivo)

  const res = await api.post('/api/messages/anexos', formData, {
    onUploadProgress: onProgress,
  })

  const data = res.data
  if (typeof data === 'string') {
    return { url: data, filename: arquivo?.name }
  }
  return {
    url: data?.url ?? null,
    filename: data?.filename ?? arquivo?.name,
  }
}

async function buscaListaPedidos(chatToken, customerId) {
  const res = await api.get(`/api/order/${chatToken}/pedidos/${customerId}`)
  return res.data.pedidos
}

async function buscaPedido(chatToken, customerId, numeroPedido) {
  const res = await api.get(`/api/order/${chatToken}/pedido/${customerId}/${numeroPedido}`)
  return res.data.pedido
}

async function vincularCPF(chatToken, numeroPedido, customerId) {
  const res = await api.get(`/api/order/${chatToken}/pedido/${customerId}/new/${numeroPedido}`)
  return res.data.pedidos
}

async function resolveTicket(ticketId, accountId, clientId, conversationExpired) {
  console.log('dados: ', ticketId, accountId, clientId, conversationExpired)
  const res = await api.get(`/api/messages/resolve/${ticketId}/${accountId}/${clientId}?conversation_expired=${conversationExpired}`)
  return res.data
}

async function buscaAtendentes(accountId) {
  const res = await api.get(`/api/messages/ticket/atendente/${accountId}`)
  return res.data
}

async function vincularAtendente(ticketId, atendenteId, accountId) {
  const res = await api.post('/api/messages/ticket/atendente', {
    ticketId,
    atendenteId,
    accountId,
  })
  return res.data
}

async function listarTemplates(accountId, apenasAprovados = false) {
  const res = await api.get(`/api/messages/templates/${accountId}`)
  
  // Se apenasAprovados = true, filtra apenas templates com status APPROVED
  if (apenasAprovados && res.data && res.data.templates) {
    return {
      ...res.data,
      templates: res.data.templates.filter(t => t.status === 'APPROVED'),
    }
  }
  
  return res.data
}

async function excluirTemplate(accountId, templateName) {
  const res = await api.delete(`/api/messages/templates/${accountId}/${templateName}`)
  return res.data
}

async function criarTemplate(accountId, templateData) {
  const res = await api.post(`/api/messages/templates/${accountId}`, templateData)
  return res.data
}

async function enviarTemplate(accountId, templateName, clientId) {
  const res = await api.post(`/api/messages/templates/${accountId}/send`, {
    templateName,
    clientId,
  })
  return res
}

async function buscaChats() {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const res = await api.get(`/api/attendants/chat/user/${userData.id}`)
  return res.data
}

async function buscaChatsTeste() {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const res = await api.get(`/api/attendants/chats/${userData.id}`)
  return res.data
}

async function buscaTag(accountId) {
  const res = await api.get(`/api/messages/tags/${accountId}`)
  return res.data.tags
}

async function createTag(accountId, nome, cor) {
  const res = await api.post(`/api/messages/tags/${accountId}`, {
    accountId,
    nome,
    cor,
  })
  return res
}

async function updateTag(tagId, nome, cor) {
  const res = await api.put(`/api/messages/tags/${tagId}`, {
    nome,
    cor,
  })
  return res
}

async function deleteTag(tagId) {
  const res = await api.delete(`/api/messages/tags/${tagId}`)
  return res
}

async function addTagToChat(atendimentoId, tags) {
  const res = await api.post(`/api/messages/tags/atendimento/${atendimentoId}`, {
    tags,
  })
  return res
}

async function buscaMetricas(chatToken, mes, ano) {
  const metricas = await api.get(
    `/api/report/agent/${chatToken}?ano=${ano}&mes=${mes}`,
  )

  console.log('metricas', metricas.data)
  return metricas.data
}

async function buscaContato(chatToken, whatsapp) {
  const contato = await api.get(
    `/api/messages/contato/${chatToken}/${whatsapp}`,
  )

  return contato.data
}

async function iniciarAtendimento(chatToken, whatsapp, templateName, atendenteId, atendimentoId, message, nome) {
  console.log("iniciarAtendimento: ", chatToken, whatsapp, templateName, atendenteId, atendimentoId, message, nome)
  const novaConversa = await api.post(
    '/api/messages/novo/atendimento', {
      accountId: chatToken,
      from: whatsapp,
      ticketId: atendimentoId,
      templateName,
      atendenteId,
      atendimentoId,
      message,
      nome
    },
  )

  return novaConversa.data
}

async function criarContato(chatToken, whatsapp, nome) {
  console.log(chatToken, whatsapp, nome)
  const novaContato = await api.post(
    `/api/messages/contato/${chatToken}/${whatsapp}`, {
      nome,
    },
  )
  console.log(novaContato)
  return novaContato.data
}

async function marcarAtendimentoNaoLido(ticketId) {
  const novaContato = await api.post(
    `/api/messages/atendimento/${ticketId}/unread`,
  )
  return novaContato
}

async function transcreverAudio(linkAudio) {
  const novaContato = await api.post(
    '/api/messages/transcreve/audio', { linkAudio },
  )
  return novaContato
}

/**
 * Histórico de resolvidos: com fim só em YYYY-MM-DD a API corta antes do fim do dia.
 * Envia fim inclusivo como "YYYY-MM-DD 23:59:59" (axios codifica espaço na query).
 */
function normalizeFimResolvedHistory(fim) {
  if (fim == null || fim === '') return fim
  const s = String(fim).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s} 23:59:59`
  return s
}

async function buscaResolvidos(chatToken, inicio, fim, status) {
  const contato = await api.get(
    `/api/messages/resolved/history/${chatToken}`,
    {
      params: {
        inicio,
        fim: normalizeFimResolvedHistory(fim),
        status,
      },
    },
  )

  return contato.data
}

/**
 * Busca mensagens por tag (trocadas e enviadas por dia) para relatório.
 * GET /api/report/messages-by-tag?uuid=...&tag=...&inicioPeriodo=...&fimPeriodo=...
 */
async function buscaMensagensPorTag(uuid, tag, inicioPeriodo, fimPeriodo) {
  const res = await api.get('/api/report/messages-by-tag', {
    params: {
      uuid,
      tag,
      inicioPeriodo,
      fimPeriodo,
    },
  })
  return res.data
}

/**
 * Busca mensagens por atendente (enviadas por dia) para relatório de desempenho.
 * GET /api/report/messages-by-attendant?uuid=...&atendenteId=...&inicioPeriodo=...&fimPeriodo=...
 */
async function buscaMensagensPorAtendente(uuid, atendenteId, inicioPeriodo, fimPeriodo) {
  const res = await api.get('/api/report/messages-by-attendant', {
    params: {
      uuid,
      atendenteId,
      inicioPeriodo,
      fimPeriodo,
    },
  })
  return res.data
}

/**
 * Busca mensagens enviadas pelo bot no período.
 * GET /api/report/messages-by-bot?uuid=...&inicioPeriodo=...&fimPeriodo=...
 */
async function buscaMensagensPorBot(uuid, inicioPeriodo, fimPeriodo) {
  const res = await api.get('/api/report/messages-by-bot', {
    params: {
      uuid,
      inicioPeriodo,
      fimPeriodo,
    },
  })
  return res.data
}

async function getChatInfo(chatToken) {
  const res = await api.get(`/api/messages/chat/${chatToken}/info`)

  return res.data.data
}

async function buscaAtividades(chatToken, phone, limit = 50) {
  const chatInfo = await getChatInfo(chatToken)
  const identifier = chatInfo?.whatsapp_business_id || chatToken
  
  const res = await apiAnalytics.get(`/api/stores/${identifier}/activities`, {
    params: { phone, limit },
  })
  return res.data
}

async function buscaHistoricoNotificacoesCliente(chatToken, clientId) {
  const res = await api.get(
    `/api/messages/notifications/history/${chatToken}/client/${clientId}`,
  )
  return res.data
}

async function getDashboardData(chatToken, inicio, fim) {
  try {
    const response = await api.get(
      `/api/messages/resolved/history/${chatToken}`,
      {
        params: {
          inicio,
          fim: normalizeFimResolvedHistory(fim),
        },
      },
    )

    const data = response.data.resolvidos
    const atendimentos = Array.isArray(data) ? data : []
    const totalAtendimentos = atendimentos.length
    const csatScores = atendimentos
      .map(item => item.csat_score || 0)
      .filter(score => score > 0)

    const satisfacaoMedia = csatScores.length > 0
      ? Math.round(csatScores.reduce((sum, score) => sum + score, 0) / csatScores.length)
      : 0

    const metricasPorDia = processarMetricasPorDia(atendimentos)
    const clientesUnicos = new Set(
      atendimentos.map(item => item.cliente_id || item.contato_id || item.customer_id || item.from).filter(id => id),
    ).size

    const dashboardData = {
      totalClientes: clientesUnicos || 0,
      totalAtendimentos,
      satisfacaoAtendimento: satisfacaoMedia,
      tempoEconomizado: data.tempoEconomizado || '0min',
      metricasAtendimento: metricasPorDia,
      campanhasWhatsapp: data.campanhasWhatsapp || [],
      analiseRFM: data.analiseRFM || {},
      topClientes: data.topClientes || [],
      produtosMaisVendidos: data.produtosMaisVendidos || [],
      ultimasCampanhas: data.ultimasCampanhas || [],
    }

    return dashboardData
  } catch (error) {
    throw error
  }
}

function processarMetricasPorDia(atendimentos) {
  const metricas = {
    labels: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
    atendimentosBot: [0, 0, 0, 0, 0, 0, 0],
    atendimentosHumano: [0, 0, 0, 0, 0, 0, 0],
  }

  atendimentos.forEach((atendimento, index) => {
    let dataAtendimento
    if (atendimento.inicio) {
      dataAtendimento = new Date(atendimento.inicio)
    } else if (atendimento.data_resolucao) {
      dataAtendimento = new Date(atendimento.data_resolucao)
    } else if (atendimento.created_at) {
      dataAtendimento = new Date(atendimento.created_at)
    } else if (atendimento.timestamp) {
      dataAtendimento = new Date(atendimento.timestamp)
    } else if (atendimento.date) {
      dataAtendimento = new Date(atendimento.date)
    } else {
      return // Pular se não tiver data
    }

    // Verificar se a data é válida
    if (isNaN(dataAtendimento.getTime())) {
      return
    }

    const diaSemana = dataAtendimento.getDay()

    const indice = diaSemana === 0 ? 6 : diaSemana - 1

    const foiBot = atendimento.atendimento_bot === true || atendimento.bot === true

    if (foiBot) {
      metricas.atendimentosBot[indice]++
    } else {
      metricas.atendimentosHumano[indice]++
    }
  })

  return metricas
}

async function criarAtalho(data) {
  const contato = await api.post(
    '/api/messages/atalhos', data,
  )

  return contato.data
}

async function buscaNotasCliente(clienteId) {
  const res = await api.get(`/api/notes/${clienteId}`)
  return res.data.notas
}

async function criarNota(note, clienteId) {
  const res = await api.post('/api/notes', {
    note,
    cliente_id: clienteId,
  })
  return res.data
}

async function editarNota(id, note) {
  const res = await api.put(`/api/notes/${id}`, { note })
  return res.data
}

async function excluirNota(id) {
  const res = await api.delete(`/api/notes/${id}`)
  return res.data
}

async function editarAtalho(data) {
  const contato = await api.put(
    '/api/messages/atalhos', data,
  )

  return contato.data
}

async function deletarAtalho(id) {
  const contato = await api.delete(
    `/api/messages/atalhos/${id}`,
  )

  return contato.data
}

// Reagir a uma mensagem do WhatsApp
// POST /api/message-actions/react — body: { waId, emoji, accountId }
async function reactToMessage(accountId, waId, emoji) {
  const res = await api.post('/api/message-actions/react', {
    waId: normalizeWaIdForHistoricoApi(waId),
    emoji,
    accountId: String(accountId ?? '').trim(),
  })
  return res.data
}

// Remover reação de uma mensagem do WhatsApp (envia emoji vazio)
async function removeReactionFromMessage(accountId, waId) {
  const res = await api.post('/api/message-actions/react', {
    waId: normalizeWaIdForHistoricoApi(waId),
    emoji: '',
    accountId: String(accountId ?? '').trim(),
  })
  return res.data
}

// Responder (quotar) uma mensagem do WhatsApp
async function replyToMessage(accountUuid, whatsappId, replyText, to) {
  await api.post('/api/message-actions/reply', {
    messageId: whatsappId,
    replyText,
    accountId: accountUuid,
    to,
  })
}

/**
 * POST /api/copilot/suggest — contrato em COPILOT_SUGGEST_FRONTEND.md
 * @param {object} params
 * @param {'create'|'improve'|'tone'} params.type
 * @param {string} [params.message] obrigatório para improve/tone com texto do rascunho
 * @param {string} [params.context]
 * @param {string|null} [params.category] filtro de prompt no backend
 * @param {string} [params.personality]
 * @param {string|null} [params.atendimentoId] para histórico no Mongo quando conversationHistory vazio
 * @param {Array<{remetente:string,texto:string,tipo?:string,timestamp?:string}>} [params.conversationHistory]
 * @param {number} [params.options] 1–5 (mais de 1 → resposta em data.options)
 * @param {string} [params.instructions] até 4000 caracteres — opcional; regras fixas vêm do backend (`central-chat-api-server`)
 */
async function copilotSuggest(params = {}) {
  const {
    type = 'create',
    message,
    context,
    category,
    personality = 'neutra',
    atendimentoId,
    conversationHistory,
    options = 3,
    instructions,
  } = params

  const payload = {
    type,
    personality: personality || 'neutra',
    options: Math.min(5, Math.max(1, Number(options) || 1)),
  }

  if (context != null && String(context).trim() !== '') {
    payload.context = String(context).trim()
  }
  if (category != null && String(category).trim() !== '') {
    payload.category = String(category).trim()
  }
  if (atendimentoId != null && String(atendimentoId).trim() !== '') {
    payload.atendimento_id = String(atendimentoId).trim()
  }
  if (Array.isArray(conversationHistory) && conversationHistory.length > 0) {
    payload.conversationHistory = conversationHistory
  }
  if (message != null && String(message).trim() !== '') {
    payload.message = String(message).trim().slice(0, 1000)
  }
  if (instructions != null && String(instructions).trim() !== '') {
    payload.instructions = String(instructions).trim().slice(0, 4000)
  }

  const res = await api.post('/api/copilot/suggest', payload, { timeout: 120000 })
  return res.data
}

async function search(chat_id, term) {
  console.log(chat_id, term)
  const search = await api.get(
    `/api/messages/search/${chat_id}`,
    { params: { q: term } },
  )

  return search.data
}

/**
 * Valor bruto do id de mensagem WhatsApp antes de ir para a query string.
 * Se `referencia_mensagem_id` já vier codificado (ex.: ...QQA%3D), evita dupla codificação
 * no Axios (%253D), que quebraria o match no backend.
 */
function normalizeWaIdForHistoricoApi(waId) {
  let s = String(waId ?? '').trim()
  if (!s) return s
  for (let i = 0; i < 3; i += 1) {
    try {
      const decoded = decodeURIComponent(s)
      if (decoded === s) break
      s = decoded
    } catch {
      break
    }
  }
  return s
}

/**
 * Busca uma mensagem citada que está fora do histórico carregado do atendimento atual
 * (ex.: cliente responde mensagem de sessão anterior).
 * GET .../historico-por-whatsapp/:chatToken/cliente/:clienteId?waId=wamid...
 *
 * Na URL final, o "=" final do wamid aparece como %3D — é o encoding correto do valor do
 * parâmetro `waId` (o servidor decodifica para wamid....= antes de buscar).
 *
 * A API homolog usa HTTP 404 com `{ error: string }` quando não há mensagem para o par
 * cliente + waId (não indica URL inválida). Nesses casos devolvemos null sem lançar.
 *
 * @returns {Promise<object|null>} Em sucesso, o corpo é o de `getHistoricoAtendimentoPorWhatsappId` no backend:
 *   `{ atendimento_id, chat_id, cliente_id, messages: [...] }`. Para exibir a citação, use a mensagem em
 *   `messages` cujo `whatsapp_id` coincide com o `waId` pedido. Retorna null em 404/400 ou erro tratável.
 */
async function historicoPorWhatsApp(chatToken, clienteId, waId) {
  const waIdRaw = normalizeWaIdForHistoricoApi(waId)
  const token = String(chatToken ?? '').trim()
  const cliente = String(clienteId ?? '').trim()
  const path = `/api/messages/atendimento/historico-por-whatsapp/${token}/cliente/${cliente}`
  const qs = new URLSearchParams()
  qs.set('waId', waIdRaw)
  const res = await api.get(`${path}?${qs.toString()}`, {
    validateStatus: status => (status >= 200 && status < 300) || status === 404 || status === 400,
  })

  if (res.status >= 200 && res.status < 300) {
    const body = res.data
    if (body && typeof body === 'object' && body.error) return null
    return body
  }

  // 400/404: cliente inválido no chat ou mensagem não persistida para esse whatsapp_id
  return null
}

/**
 * Busca o horário de funcionamento da central de atendimento.
 * GET /api/messages/chat/{chatToken}/horario-funcionamento
 */
async function getHorarioFuncionamento(chatToken) {
  const res = await api.get(`/api/messages/chat/${chatToken}/horario-funcionamento`)
  return res.data
}

/**
 * Atualiza o horário de funcionamento da central de atendimento.
 * PUT /api/messages/chat/{chatToken}/horario-funcionamento
 * Body: { horarioFuncionamento: [ { dia: 0-6, abre: "08:00", fecha: "12:00" }, ... ] }
 */
async function putHorarioFuncionamento(chatToken, horarioFuncionamento) {
  const res = await api.put(`/api/messages/chat/${chatToken}/horario-funcionamento`, {
    horarioFuncionamento,
  })
  return res.data
}

// Upload de mídia para templates (IMAGE ou VIDEO)
async function uploadTemplateMedia(file, chatToken) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('chatToken', chatToken)

  const res = await api.post('/api/templates/upload-media', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return res.data // Retorna { media_id, media_url, media_type }
}

async function buscaNotasCliente(clienteId) {
  const res = await api.get(`/api/notes/${clienteId}`)
  return res.data.notas
}

async function criarNota(note, clienteId) {
  const res = await api.post('/api/notes', { note, cliente_id: clienteId })
  return res.data
}

async function editarNota(id, note) {
  const res = await api.put(`/api/notes/${id}`, { note })
  return res.data
}

async function excluirNota(id) {
  const res = await api.delete(`/api/notes/${id}`)
  return res.data
}

async function getStore(uuid) {
  const res = await api.get(`/api/stores/${uuid}`)
  return res.data
}

module.exports = {
  getChatOfContact,
  getAttendings,
  sendMessage,
  enviarAnexo,
  buscaListaPedidos,
  buscaPedido,
  vincularCPF,
  resolveTicket,
  buscaAtendentes,
  vincularAtendente,
  listarTemplates,
  excluirTemplate,
  criarTemplate,
  enviarTemplate,
  buscaChats,
  buscaTag,
  createTag,
  updateTag,
  deleteTag,
  addTagToChat,
  buscaMetricas,
  buscaContato,
  criarContato,
  iniciarAtendimento,
  marcarAtendimentoNaoLido,
  transcreverAudio,
  buscaResolvidos,
  buscaMensagensPorTag,
  buscaMensagensPorAtendente,
  buscaMensagensPorBot,
  buscaAtividades,
  buscaHistoricoNotificacoesCliente,
  getHorarioFuncionamento,
  historicoPorWhatsApp,
  putHorarioFuncionamento,
  getDashboardData,
  criarAtalho,
  editarAtalho,
  deletarAtalho,
  buscaChatsTeste,
  search,
  reactToMessage,
  removeReactionFromMessage,
  replyToMessage,
  copilotSuggest,
  uploadTemplateMedia,
  buscarProdutos,
  getStore,
  buscaNotasCliente,
  criarNota,
  editarNota,
  excluirNota,
}

/**
 * Mensagem legível a partir de respostas de erro HTTP (axios) ou corpo JSON com message/error.
 */
function extrairMensagemErroApi(error, fallback = 'Erro ao comunicar com o servidor.') {
  if (!error) return fallback
  if (error.response && error.response.data != null) {
    const d = error.response.data
    if (typeof d === 'string' && d.trim()) return d.trim()
    if (typeof d.message === 'string' && d.message.trim()) return d.message.trim()
    if (typeof d.error === 'string' && d.error.trim()) return d.error.trim()
    if (d.errors && typeof d.errors === 'object') {
      const vals = Object.values(d.errors)
      const first = vals[0]
      if (Array.isArray(first) && first[0]) return String(first[0])
      if (typeof first === 'string' && first.trim()) return first.trim()
    }
  }
  if (error.message && String(error.message).trim()) return String(error.message).trim()
  return fallback
}

// Função para buscar produtos na API
async function buscarProdutos(termo, token, type = 'name') {
  try {
    const params = {
      token: token || 'teste',
      query: termo || '',
      type: type,
    }
    
    console.log('🔍 Buscando produtos na API:', params)
    
    const response = await api.get('/api/search/products', { params })
    
    console.log('✅ Resposta da API:', response.data)

    const body = response.data
    if (!body.success) {
      const msg = (body.message || body.error || 'Não foi possível buscar produtos.').toString().trim()
      throw new Error(msg || 'Não foi possível buscar produtos.')
    }
    
    // Mapear produtos conforme o tipo de busca
    if (body.data && body.data.produtos) {
      const produtos = body.data.produtos
      const produtosMapeados = []
      const searchType = body.searchType
      
      // Se for busca por SKU, os produtos já vêm expandidos
      if (searchType === 'sku') {
        produtos.forEach(produto => {
          if (produto.ativo) {
            produtosMapeados.push({
              id: produto.derivacaoId || produto.id,
              codigo: produto.codigo,
              nome: produto.titulo || produto.nome,
              preco: produto.valor || 0,
              link: produto.link,
              estoque: produto.qtdeEstoque || 0,
              imagem: produto.imagemPrincipal || 'https://via.placeholder.com/80x80?text=Produto',
              produtoPai: {
                id: produto.id,
                nome: produto.nome,
                codigo: produto.codigo,
                modelo: produto.modelo,
              },
            })
          }
        })
        console.log('📦 Produtos mapeados (busca por SKU):', produtosMapeados)
      } else {
        // Busca por nome: formato com array `derivacoes` (legado) ou produto já “achatado” (derivacaoId, valor, imagemPrincipal, etc.)
        produtos.forEach(produto => {
          if (produto.derivacoes && Array.isArray(produto.derivacoes) && produto.derivacoes.length > 0) {
            produto.derivacoes.forEach(derivacao => {
              if (derivacao.ativo !== false) {
                produtosMapeados.push({
                  id: derivacao.id,
                  codigo: derivacao.codigo,
                  nome: derivacao.nome || produto.titulo || produto.nome,
                  preco: Number(
                    derivacao.preco != null
                      ? derivacao.preco
                      : (produto.valor != null ? produto.valor : produto.preco),
                  ) || 0,
                  estoque: derivacao.estoque != null
                    ? derivacao.estoque
                    : (produto.qtdeEstoque != null ? produto.qtdeEstoque : (produto.estoque || 0)),
                  imagem: derivacao.imagem
                    || produto.imagemPrincipal
                    || produto.imagem
                    || 'https://via.placeholder.com/80x80?text=Produto',
                  link: derivacao.link || produto.link || null,
                  valorDe: derivacao.valorDe != null ? derivacao.valorDe : produto.valorDe,
                  percentualDesconto: derivacao.percentualDesconto != null
                    ? derivacao.percentualDesconto
                    : produto.percentualDesconto,
                  marca: produto.marca,
                  produtoPai: {
                    id: produto.id,
                    nome: produto.nome,
                    codigo: produto.codigo,
                    modelo: produto.modelo,
                  },
                })
              }
            })
          } else if (produto.ativo !== false) {
            const idLinha = produto.derivacaoId != null ? produto.derivacaoId : produto.id
            const idItem = idLinha != null && idLinha !== '' ? idLinha : produto.codigo
            if (idItem == null || idItem === '') return

            produtosMapeados.push({
              id: idItem,
              codigo: produto.codigo,
              nome: produto.titulo || produto.nome || produto.derivacaoNome,
              preco: Number(produto.valor != null ? produto.valor : produto.preco) || 0,
              estoque: produto.qtdeEstoque != null ? produto.qtdeEstoque : (produto.estoque || 0),
              imagem: produto.imagemPrincipal
                || produto.imagem
                || 'https://via.placeholder.com/80x80?text=Produto',
              link: produto.link || null,
              valorDe: produto.valorDe,
              percentualDesconto: produto.percentualDesconto,
              marca: produto.marca,
              complemento: produto.complemento,
              produtoPai: {
                id: produto.id,
                nome: produto.nome,
                codigo: produto.codigo,
                modelo: produto.modelo,
              },
            })
          }
        })
        console.log('📦 Produtos mapeados (busca por nome):', produtosMapeados)
      }
      
      return produtosMapeados
    }
    
    // Se não houver produtos ou estrutura diferente, retornar array vazio
    console.log('⚠️ Nenhum produto encontrado na resposta')
    return []
  } catch (error) {
    console.error('❌ Erro ao buscar produtos na API:', error)
    if (error && error.message && !error.response) {
      throw error
    }
    throw new Error(extrairMensagemErroApi(error, 'Erro ao buscar produtos.'))
  }
}
